import API from 'services/API/index';

export default function getJudicialActs() {
  return API.request({
    method: 'GET',
    url: '/taxpayer/judicialAct',
    mapper: (data) => data.sort(sortJudicialActsByAppealNumber),
  });
}

function sortJudicialActsByAppealNumber(act1, act2) {
  return isNaN(+act1.appealNumber) || isNaN(+act2.appealNumber)
    ? -1
    : +act1.appealNumber - +act2.appealNumber;
}
